import React, {useState} from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import _extend from 'lodash/extend'
import LoadingIndicator from '../shared/LoadingIndicator'
import DropdownIndicator from '../shared/DropdownIndicator'
import FloatingLabel from '../shared/FloatingLabel'
import useFocussedPlaceholder from '../../utils/useFocussedPlaceholder'

import {CLASSNAME, CLASSNAME_PREFIX, componentClassName, isRequiredClassName} from '../constants'

const PhoenixSelect = (props) => {
    const {title, outlined, value, components, isCreatable, isRequired} = props
    // eslint-disable-next-line react/destructuring-assignment
    const [originalPlaceholder] = useState(props.placeholder)
    const {isFocussed, placeholder, handleOnFocus, handleOnBlur} = useFocussedPlaceholder(
        false,
        originalPlaceholder || title,
        isRequired
    )

    const CustomSelect = isCreatable ? CreatableSelect : Select
    return (
        <div className={`papi-react ${isRequiredClassName({isRequired, value})}`}>
            <div className={`phoenix-select ${componentClassName(outlined)}`}>
                <FloatingLabel
                    title={title}
                    value={value}
                    isFocussed={isFocussed}
                    isRequired={isRequired}
                    hasCustomPlaceholder={!!originalPlaceholder}
                />
                <CustomSelect
                    placeholder={placeholder}
                    className={CLASSNAME}
                    classNamePrefix={CLASSNAME_PREFIX}
                    onFocus={handleOnFocus}
                    onBlur={handleOnBlur}
                    isClearable
                    {...props}
                    components={_extend({LoadingIndicator, DropdownIndicator}, components)}
                />
            </div>
        </div>
    )
}

PhoenixSelect.displayName = 'PhoenixSelect'

PhoenixSelect.propTypes = {
    title: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    outlined: PropTypes.bool,
    isRequired: PropTypes.bool,
    isMulti: PropTypes.bool,
    isCreatable: PropTypes.bool
}

export default PhoenixSelect
